// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/81b7656c7b9596bb3e79.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"68e06a19ca1c3efd018f","216":"ec49030b5e72bff316f2","217":"4992c535b3509a061ebd"}[chunkId] + ".chunk.js";
};